import dotProp from 'dot-prop-immutable'
import {
  PHOTOS_ARE_LOADING,
  PHOTOS_CHANGE_FILTER,
  PHOTOS_FAILED,
  PHOTOS_LOADED,
  SELECT_PHOTO_SIDEBAR,
  DESELECT_PHOTO_SIDEBAR,
  REMOVE_PHOTO_SIDEBAR,
} from '../constants/photosActions'

const initialState = {
  isLoading: false,
  selectedIndex: false,
  errMessage: '',
  images: [],
  currentFilter: 'all',
}

export default function(state = initialState, action) {
  switch (action.type) {
    case PHOTOS_ARE_LOADING:
      return dotProp.set(state, 'isLoading', true)
    case PHOTOS_LOADED:
      state = dotProp.set(state, 'images', action.images)
      state = dotProp.set(state, 'isLoading', false)

      return state
    case PHOTOS_FAILED:
      state = dotProp.set(state, 'isLoading', false)
      state = dotProp.set(state, 'errMessage', action.message)

      return state
    case PHOTOS_CHANGE_FILTER:
      return dotProp.set(state, 'currentFilter', action.filter)
    case SELECT_PHOTO_SIDEBAR:
      return dotProp.set(state, 'selectedIndex', action.index)
    case DESELECT_PHOTO_SIDEBAR:
      return dotProp.set(state, 'selectedIndex', false)
    case REMOVE_PHOTO_SIDEBAR:
      return dotProp.delete(state, `images.${action.index}`)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/photos.js